import { render, staticRenderFns } from "./AvailableOpgs.vue?vue&type=template&id=7b30826a&scoped=true"
import script from "./AvailableOpgs.vue?vue&type=script&lang=js"
export * from "./AvailableOpgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b30826a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b30826a')) {
      api.createRecord('7b30826a', component.options)
    } else {
      api.reload('7b30826a', component.options)
    }
    module.hot.accept("./AvailableOpgs.vue?vue&type=template&id=7b30826a&scoped=true", function () {
      api.rerender('7b30826a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailableOpgs.vue"
export default component.exports